import { render, staticRenderFns } from "./contacts-grid.vue?vue&type=template&id=8bd18800&"
import script from "./contacts-grid.vue?vue&type=script&lang=js&"
export * from "./contacts-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports